import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { Icon, IconType } from '../icon/icon.component';
import './status.component.scss';
import { ColorType } from '../../types/component.type';
import { getCSS } from '@gimlite/common';
import { useDevice } from '../../hooks/useDevice.hook';

export declare namespace StatusType {
  type Props = {
    className?: string | null;
    icon?: IconType.Props['variant'];
    backgroundColor?: ColorType;
    foregroundColor?: ColorType;
  };
}

export const Status = observer(
  ({
    className,
    icon = 'check',
    backgroundColor = 'alert_success_20',
    foregroundColor = 'alert_success',
  }: StatusType.Props) => {
    const { isMobile } = useDevice();
    return (
      <div
        className={classNames(
          `status`,
          className,
          isMobile ? 'status--mobile' : 'status--desktop',
        )}
        style={{
          backgroundColor: getCSS(`--color-${backgroundColor}`),
        }}
      >
        <Icon
          variant={icon}
          size={isMobile ? 'm' : 'xl'}
          color={foregroundColor}
        />
      </div>
    );
  },
);
